import { gql } from '@apollo/client'
import {
  ArticleGridBlockFragment,
  BaseArticleBlock,
  FeaturedArticleBlockFragment,
  WriteForUsBlockFragment,
} from 'app/features/blog/blocks'
import {
  FeaturedContentBlockFragment,
  FeaturedContentCarouselBlockFragment,
  RichTextBlockFragment,
  SpacerBlockFragment,
} from 'app/features/shared/blocks'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchBlogHome($draft: Boolean!) {
    BlogHome(draft: $draft) {
      content {
        ${ArticleGridBlockFragment.partialFragment}
        ${FeaturedArticleBlockFragment.partialFragment}
        ${FeaturedContentBlockFragment.partialFragment}
        ${FeaturedContentCarouselBlockFragment.partialFragment}
        ${RichTextBlockFragment.partialFragment}
        ${SpacerBlockFragment.partialFragment}
        ${WriteForUsBlockFragment.partialFragment}
      }
      meta {
        title
        description
      }
    }

    Articles(limit: 1) {
      totalDocs
    }
  }
`

export interface BlogHomeQueryInput {
  draft: boolean
}

export interface BlogHomeQueryOutput {
  BlogHome: {
    content: BaseArticleBlock[]
    meta: {
      title: string
      description: string
    }
  }
  Articles: {
    totalDocs: number
  }
}

export const useBlogHomeQuery = (input: BlogHomeQueryInput) =>
  usePersistedCacheQuery<BlogHomeQueryOutput, BlogHomeQueryInput>(query, { variables: input })

export const fetchBlogHomeQuery = { query }
